import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";

var _Validation$messages;

import isNumber from 'lodash/isNumber';
import isFinite from 'lodash/isFinite';
import isArray from 'lodash/isArray';
import isBoolean from 'lodash/isBoolean';
import isDate from 'lodash/isDate';
import isEmpty from 'lodash/isEmpty';
import toArray from 'lodash/values';
import isObject from 'lodash/isObject';
import isUndefined from 'lodash/isUndefined';
import isNil from 'lodash/isNil';
import get from 'lodash/get';
import { GROUP_SEPARATOR, POSITION_SEPARATOR } from './Form';
import Api from '../../api';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
export var ValidationTypesEnum;

(function (ValidationTypesEnum) {
  ValidationTypesEnum["REQUIRED"] = "required";
  ValidationTypesEnum["EMAIL"] = "email";
  ValidationTypesEnum["PASSWORD"] = "password";
  ValidationTypesEnum["NUMBER"] = "number";
  ValidationTypesEnum["URL"] = "url";
  ValidationTypesEnum["COMPARE"] = "compare";
  ValidationTypesEnum["MIN_LENGTH"] = "min-length";
  ValidationTypesEnum["MAX_LENGTH"] = "max-length";
  ValidationTypesEnum["RANGE_LENGTH"] = "range-length";
  ValidationTypesEnum["MIN_VALUE"] = "min-value";
  ValidationTypesEnum["MAX_VALUE"] = "max-value";
  ValidationTypesEnum["RANGE_VALUE"] = "range-value";
  ValidationTypesEnum["ASYNC"] = "async";
  ValidationTypesEnum["MIN_COUNT"] = "min-count";
  ValidationTypesEnum["MAX_COUNT"] = "max-count";
  ValidationTypesEnum["RANGE_COUNT"] = "range-count";
  ValidationTypesEnum["REGEXP"] = "regexp";
})(ValidationTypesEnum || (ValidationTypesEnum = {}));

var Validation =
/*#__PURE__*/
function () {
  function Validation(rules, fieldDependency) {
    var _this = this;

    _classCallCheck(this, Validation);

    /**
     * Правила валидации. Получаем от формы в конструкторе
     */
    this.rules = {};
    /**
     * Обязательные поля: '1' - если однозначно, либо массив зависимостей, если надо проверять зависимые поля.
     */

    this.requiredFields = {};
    /**
     * Поля со списками имен полей, правила которых зависят от соответствующего поля
     */

    this.dependsFields = {};
    /**
     * Возвращает true, если указанная зависимость выполняется
     * @param dependency
     */

    this.resolveDependency = function (dependency) {
      if (!_this.fieldDependency) return false;
      return _this.fieldDependency.resolve(dependency, true);
    };
    /**
     * Поверка всех значений формы согласно правилам
     * @param values Список значений полей
     * @param labels Список наименований полей
     * @param noValidateKeys Список наименований полей, не подлежащих валидации
     * @param dynamicFieldsKeys Список наименований динамических полей
     */


    this.checkAll =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(values, labels, noValidateKeys, dynamicFieldsKeys) {
        var promises, _loop, fieldName;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                promises = [];

                _loop = function _loop(fieldName) {
                  if (noValidateKeys.length === 0 || !noValidateKeys.includes(fieldName)) {
                    var _fieldName$split = fieldName.split(GROUP_SEPARATOR),
                        _fieldName$split2 = _slicedToArray(_fieldName$split, 2),
                        field = _fieldName$split2[0],
                        group = _fieldName$split2[1]; // Если поле из правила есть в значениях, то проверяем поле


                    if (values.hasOwnProperty(group || field)) {
                      var value = group ? values[group][field] : values[field];

                      if (dynamicFieldsKeys.length === 0 || !dynamicFieldsKeys.includes(fieldName)) {
                        promises.push(_this.checkOne(fieldName, value, values, labels).then(function (errors) {
                          if (errors.length > 0) {
                            return {
                              id: fieldName,
                              errors: errors
                            };
                          }
                        }));
                      } else {
                        // Если поле динамическое
                        value.forEach(function (dynamicValue, index) {
                          var dynamicFieldName = "".concat(fieldName).concat(POSITION_SEPARATOR).concat(index);
                          promises.push(_this.checkOne(dynamicFieldName, dynamicValue, values, labels).then(function (errors) {
                            if (errors.length > 0) {
                              return {
                                id: dynamicFieldName,
                                errors: errors
                              };
                            }
                          }));
                        });
                      }
                    }
                  }
                };

                for (fieldName in _this.rules) {
                  _loop(fieldName);
                }

                return _context.abrupt("return", Promise.all(promises).then(function (errors) {
                  return errors.filter(function (error) {
                    return !isUndefined(error);
                  });
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * Поверка всех значений группы согласно правилам
     * @param groupName Идентификатор группы
     * @param values Список значений полей
     * @param labels Список наименований полей
     * @param hiddenFields Список наименований полей, не подлежащих валидации
     */


    this.checkDynamicGroup =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(groupName, values, labels, hiddenFields) {
        var promises, _loop2, fieldName;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                promises = [];

                _loop2 = function _loop2(fieldName) {
                  var _fieldName$split3 = fieldName.split(GROUP_SEPARATOR),
                      _fieldName$split4 = _slicedToArray(_fieldName$split3, 2),
                      field = _fieldName$split4[0],
                      group = _fieldName$split4[1];

                  if (group && group === groupName && values.hasOwnProperty(field) && (hiddenFields.length === 0 || !hiddenFields.includes(fieldName))) {
                    promises.push(_this.checkOne(fieldName, values[field], values, labels).then(function (errors) {
                      if (errors.length > 0) {
                        return {
                          id: fieldName,
                          errors: errors
                        };
                      }
                    }));
                  }
                };

                for (fieldName in _this.rules) {
                  _loop2(fieldName);
                }

                return _context2.abrupt("return", Promise.all(promises).then(function (errors) {
                  return errors.filter(function (error) {
                    return !isUndefined(error);
                  });
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x5, _x6, _x7, _x8) {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     * Проверка одного значения согласно правилу
     * @param ID Идентификатор поля
     * @param value Текущее значение поля
     * @param values Список значений полей
     * @param labels Список наименований полей
     */


    this.checkOne =
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(ID, value, values, labels) {
        var _ID$split, _ID$split2, id, promises;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ID$split = ID.split(POSITION_SEPARATOR), _ID$split2 = _slicedToArray(_ID$split, 1), id = _ID$split2[0]; // Если поле не валидируется

                if (!isUndefined(_this.rules[id])) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", []);

              case 3:
                promises = [];

                _this.rules[id].forEach(function (rule) {
                  var checkParams = {};
                  var messageParams = []; // Если нужно сравнить, то в параметры проверки добавляем значение поля
                  // а в параметры сообщения добавляем наименование поля

                  if (rule.type === ValidationTypesEnum.COMPARE) {
                    var compareFieldName = rule.params.compareField;

                    var _compareFieldName$spl = compareFieldName.split(GROUP_SEPARATOR),
                        _compareFieldName$spl2 = _slicedToArray(_compareFieldName$spl, 2),
                        compareField = _compareFieldName$spl2[0],
                        compareGroup = _compareFieldName$spl2[1];

                    var compareValue = compareGroup ? values[compareGroup] && values[compareGroup][compareField] : values[compareField];
                    checkParams = {
                      compareValue: compareValue
                    };
                    messageParams.push(labels[compareFieldName]);
                  }

                  if (!rule.dependency || _this.resolveDependency(rule.dependency)) promises.push(Validation.check(rule.type, value, rule.params, checkParams).then(function (result) {
                    if (isObject(result) && !result.status || !result) {
                      return Validation.createMessage(rule.type, messageParams.concat(toArray(rule.params)), isObject(result) && result.message ? result.message : rule.message);
                    }

                    return '';
                  }));
                });

                if (!(promises.length === 0)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", []);

              case 7:
                return _context3.abrupt("return", Promise.all(promises).then(function (errors) {
                  return errors.filter(function (error) {
                    return error !== '';
                  });
                }));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x9, _x10, _x11, _x12) {
        return _ref3.apply(this, arguments);
      };
    }();

    var processOneRule = function processOneRule(fieldName, rule) {
      // Добавляем новое правило в this.rules
      var newRule = isObject(rule) ? rule : {
        type: rule
      };

      _this.rules[fieldName].push(newRule); // Если правило содержит зависимости, то сохраняем кто от кого зависит


      if (newRule.dependency && newRule.dependency.dependsOn) {
        var masterField = newRule.dependency.dependsOn;
        if (!_this.dependsFields[masterField]) _this.dependsFields[masterField] = [];
        if (!_this.dependsFields[masterField].includes(fieldName)) _this.dependsFields[masterField].push(fieldName);
      } // Если это правило обязательности, добавляем его в requiredFields


      if (newRule.type === ValidationTypesEnum.REQUIRED && (!_this.requiredFields[fieldName] || _this.requiredFields[fieldName] !== '1')) {
        if (!newRule.dependency) _this.requiredFields[fieldName] = '1';else {
          if (!_this.requiredFields[fieldName]) _this.requiredFields[fieldName] = [];

          _this.requiredFields[fieldName].push(newRule.dependency);
        }
      }
    };

    this.fieldDependency = fieldDependency; // Приводим полученные правила к одному формату

    var _loop3 = function _loop3(fieldName) {
      _this.rules[fieldName] = [];
      var rule = rules[fieldName];
      if (isArray(rule)) //если массив правил
        rule.forEach(function (rule) {
          return processOneRule(fieldName, rule);
        });else processOneRule(fieldName, rule);
    };

    for (var fieldName in rules) {
      _loop3(fieldName);
    }
  }
  /**
   * Возвращает true, если данное поле обязательное (с учетом зависимых валидаций)
   * @param fieldName
   */


  _createClass(Validation, [{
    key: "isRequiredField",
    value: function isRequiredField(fieldName) {
      return !!(this.requiredFields[fieldName] && (this.requiredFields[fieldName] === '1' || this.requiredFields[fieldName].find(this.resolveDependency)));
    }
    /**
     * Возвращает массив имен полей, правила валидации которых зависят от указанного поля
     * @param fieldName
     */

  }, {
    key: "getDependsFields",
    value: function getDependsFields(fieldName) {
      if (!this.dependsFields[fieldName]) return [];
      return _toConsumableArray(this.dependsFields[fieldName]);
    }
    /**
     * Проверка значения на пустоту
     * @param value Значение
     */

  }], [{
    key: "checkEmpty",
    value: function checkEmpty(value) {
      if (isBoolean(value)) {
        return false;
      }

      if (isDate(value) || isNumber(value)) {
        value = value.toString();
      }

      return isEmpty(value);
    }
    /**
     * Проверка значения на обязательность
     * @param value Значение
     */

  }, {
    key: "checkRequired",
    value: function checkRequired(value) {
      if (typeof value === 'object') {
        return !isEmpty(value);
      } // особый случай, если поле изначально проинициализировано нулем и не менялось, то считать это допустимым
      // для правила REQUIRED


      if (value === 0) return true;
      return !!value;
    }
    /**
     * Проверка email
     * @param value Значение
     */

  }, {
    key: "checkEmail",
    value: function checkEmail(value) {
      if (!value) {
        return true;
      }

      var emailRex = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return typeof value === 'string' && emailRex.test(value);
    }
    /**
     * Проверка длины
     * @param value Значение
     * @param length Длина
     */

  }, {
    key: "checkLength",
    value: function checkLength(value, length) {
      return typeof value === 'string' && value.length >= length;
    }
    /**
     * Проверка количества элементов в массиве
     * @param value Значение
     * @param length Длина
     */

  }, {
    key: "checkCount",
    value: function checkCount(value, length) {
      return isArray(value) && value.length >= length;
    }
    /**
     * Проверка на идентичность
     * @param value1 Сравниваемое значение
     * @param value2 Проверочное значение
     */

  }, {
    key: "compare",
    value: function compare(value1, value2) {
      return value1 === value2;
    }
    /**
     * Проверка на число
     * @param value Значение
     */

  }, {
    key: "checkNumber",
    value: function checkNumber(value) {
      return /^-?[\d.]+(?:e-?\d+)?$/.test(value);
    }
    /**
     * Проверка url
     * @param value Значение
     */

  }, {
    key: "checkUrl",
    value: function checkUrl(value) {
      if (typeof value === 'string' && value.search(/https?:\/\//i) === 0) {
        try {
          new URL(value);
          return true;
        } catch (_) {
          return false;
        }
      } else {
        return false;
      }
    }
    /**
     * Проверка значения
     * @param value Значение
     * @param testValue Проверочное значение
     */

  }, {
    key: "checkValue",
    value: function checkValue(value, testValue) {
      value = Number(value);
      return isFinite(value) && value >= testValue;
    }
    /**
     * Асинхронная проверка значения
     * @param url
     * @param requestAdapter
     * @param responseAdapter
     * @param value
     */

  }, {
    key: "asyncCheck",
    value: function asyncCheck(_ref4, value) {
      var url = _ref4.url,
          requestAdapter = _ref4.requestAdapter,
          responseAdapter = _ref4.responseAdapter;

      if (!value || typeof value === 'object' && Object.keys(value).length === 0) {
        return Promise.resolve({
          status: true,
          message: ''
        });
      }

      return Api.get(url, requestAdapter ? requestAdapter(value) : {
        value: value
      }).pipe(map(responseAdapter ? responseAdapter : function (data) {
        return {
          status: get(data, 'response.status', true),
          message: get(data, 'response.message', '')
        };
      }), catchError(function (err) {
        return of(err.message);
      })).toPromise();
    }
    /**
     * Проверка значения по регулярке
     * @param value - значение
     * @param regexp - регулярное выражение
     */

  }, {
    key: "checkRegexp",
    value: function checkRegexp(value, regexp) {
      return !!value.match(new RegExp(regexp));
    }
    /**
     * Валидация значения по типу и параметрам
     * @param type Тип правила
     * @param value Значение поля /todo any -> TFieldValue
     * @param params Праметры правила
     * @param checkParams Параметры проверки
     */

  }, {
    key: "check",
    value: function () {
      var _check = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(type, value, params, checkParams) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(type !== ValidationTypesEnum.REQUIRED && type !== ValidationTypesEnum.COMPARE && type !== ValidationTypesEnum.ASYNC && type !== ValidationTypesEnum.PASSWORD && (isNil(value) || value === ''))) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", true);

              case 2:
                _context4.t0 = type;
                _context4.next = _context4.t0 === ValidationTypesEnum.REQUIRED ? 5 : _context4.t0 === ValidationTypesEnum.EMAIL ? 6 : _context4.t0 === ValidationTypesEnum.PASSWORD ? 7 : _context4.t0 === ValidationTypesEnum.NUMBER ? 8 : _context4.t0 === ValidationTypesEnum.URL ? 9 : _context4.t0 === ValidationTypesEnum.COMPARE ? 10 : _context4.t0 === ValidationTypesEnum.MIN_LENGTH ? 11 : _context4.t0 === ValidationTypesEnum.MAX_LENGTH ? 12 : _context4.t0 === ValidationTypesEnum.RANGE_LENGTH ? 13 : _context4.t0 === ValidationTypesEnum.MIN_VALUE ? 14 : _context4.t0 === ValidationTypesEnum.MAX_VALUE ? 15 : _context4.t0 === ValidationTypesEnum.RANGE_VALUE ? 16 : _context4.t0 === ValidationTypesEnum.ASYNC ? 17 : _context4.t0 === ValidationTypesEnum.MIN_COUNT ? 18 : _context4.t0 === ValidationTypesEnum.MAX_COUNT ? 19 : _context4.t0 === ValidationTypesEnum.RANGE_COUNT ? 20 : _context4.t0 === ValidationTypesEnum.REGEXP ? 21 : 22;
                break;

              case 5:
                return _context4.abrupt("return", Validation.checkRequired(value));

              case 6:
                return _context4.abrupt("return", Validation.checkEmail(value));

              case 7:
                return _context4.abrupt("return", Validation.checkLength(value, 1));

              case 8:
                return _context4.abrupt("return", Validation.checkNumber(value));

              case 9:
                return _context4.abrupt("return", Validation.checkUrl(value));

              case 10:
                return _context4.abrupt("return", !!params && Validation.compare(value, checkParams.compareValue));

              case 11:
                return _context4.abrupt("return", !!params && Validation.checkNumber(params.min) && Validation.checkLength(value, Number(params.min)));

              case 12:
                return _context4.abrupt("return", !!params && Validation.checkNumber(params.max) && !Validation.checkLength(value, Number(params.max) + 1));

              case 13:
                return _context4.abrupt("return", !!params && Validation.checkNumber(params.min) && Validation.checkLength(value, Number(params.min)) && Validation.checkNumber(params.max) && !Validation.checkLength(value, Number(params.max) + 1));

              case 14:
                return _context4.abrupt("return", !!params && Validation.checkNumber(params.min) && Validation.checkValue(value, Number(params.min)));

              case 15:
                return _context4.abrupt("return", !!params && Validation.checkNumber(params.max) && !Validation.checkValue(value, Number(params.max) + 1));

              case 16:
                return _context4.abrupt("return", !!params && Validation.checkNumber(params.min) && Validation.checkValue(value, Number(params.min)) && Validation.checkNumber(params.max) && !Validation.checkValue(value, Number(params.max) + 1));

              case 17:
                return _context4.abrupt("return", Validation.asyncCheck(params, value));

              case 18:
                return _context4.abrupt("return", !!params && Validation.checkNumber(params.min) && Validation.checkCount(value, Number(params.min)));

              case 19:
                return _context4.abrupt("return", !!params && Validation.checkNumber(params.max) && !Validation.checkCount(value, Number(params.max) + 1));

              case 20:
                return _context4.abrupt("return", !!params && Validation.checkNumber(params.min) && Validation.checkCount(value, Number(params.min)) && Validation.checkNumber(params.max) && !Validation.checkCount(value, Number(params.max) + 1));

              case 21:
                return _context4.abrupt("return", !!params && Validation.checkRegexp(value, params.regexp));

              case 22:
                return _context4.abrupt("return", true);

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function check(_x13, _x14, _x15, _x16) {
        return _check.apply(this, arguments);
      }

      return check;
    }()
    /**
     * Создание сообщения об ошибке согласно типу и параметрам
     * @param type Тип правила
     * @param values array Праметры сообщения
     * @param message Кастомное сообщение
     */

  }, {
    key: "createMessage",
    value: function createMessage(type) {
      var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var message = arguments.length > 2 ? arguments[2] : undefined;
      message = message || Validation.messages[type] || '';
      return isArray(values) ? values.reduce(function (message, current) {
        return message.replace('%s', current);
      }, message) : message;
    }
  }]);

  return Validation;
}();
/**
 * Набор дефолтных сообщений об ошибке
 */


export { Validation as default };
Validation.messages = (_Validation$messages = {}, _defineProperty(_Validation$messages, ValidationTypesEnum.REQUIRED, 'Поле обязательно для заполнения'), _defineProperty(_Validation$messages, ValidationTypesEnum.EMAIL, 'Введите корректный адрес электронной почты'), _defineProperty(_Validation$messages, ValidationTypesEnum.PASSWORD, 'Поле не может быть пустым'), _defineProperty(_Validation$messages, ValidationTypesEnum.NUMBER, 'Введите число'), _defineProperty(_Validation$messages, ValidationTypesEnum.URL, 'Введите корректный адрес'), _defineProperty(_Validation$messages, ValidationTypesEnum.COMPARE, 'Не совпадает со значением поля %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.MIN_LENGTH, 'Количество символов должно быть не меньше %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.MAX_LENGTH, 'Количество символов должно быть не больше %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.RANGE_LENGTH, 'Количество символов должно быть не меньше %s и не больше %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.MIN_VALUE, 'Значение должно быть не меньше %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.MAX_VALUE, 'Значение должно быть не больше %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.RANGE_VALUE, 'Значение должно быть не меньше %s и не больше %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.ASYNC, 'Асинхронная валидация'), _defineProperty(_Validation$messages, ValidationTypesEnum.MIN_COUNT, 'Количество должно быть не меньше %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.MAX_COUNT, 'Количество должно быть не больше %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.RANGE_COUNT, 'Количество должно быть не меньше %s и не больше %s'), _defineProperty(_Validation$messages, ValidationTypesEnum.REGEXP, 'Значение должно соответствовать регулярному выражению /%s/'), _Validation$messages);